import { Link } from "react-router-dom";
import type { Series } from "@/types";

export default function SeriesCard({ series }: { series: Series }) {
  return (
    <Link
      to={`/detail/${series.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={series.cover}
          alt={`${series.title} AI短剧封面`}
          title={`${series.title} · ai短剧`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-md bg-primary-500/95 px-2 py-1 text-xs font-medium text-background-50">
          {series.categoryName}
        </span>
        <span className="absolute right-3 top-3 flex items-center gap-1 rounded-md bg-foreground-950/70 px-2 py-1 text-xs font-semibold text-background-50">
          <i className="ri-star-fill text-accent-400"></i>
          {series.score}
        </span>
        <div className="absolute inset-x-0 bottom-0 flex items-center gap-2 bg-gradient-to-t from-foreground-950/85 to-transparent px-3 pb-3 pt-8 text-[11px] font-medium text-background-100">
          <span className="rounded bg-background-50/20 px-1.5 py-0.5">{series.year}</span>
          <span>共 {series.episodes} 集</span>
        </div>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
          {series.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-500">
          {series.description}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {series.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-800"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}